module.exports = __webpack_public_path__ + "img/8.b456933.b456933b.png";